import React from "react";
import { FormattedMessage } from "react-intl";

import { translateRxOption } from "~/common/prescription";
import { LabelledValue } from "~/components/ui/labelled-value";
import type { TPrescription } from "~/types/prescription";

export function PatientCardCanines({ prescription: { canine_ratio_right, canine_ratio_left, canine_method_ai, canine_method, canine_ipr } }: { prescription: TPrescription }) {
  return (
    <div>
      <div className="tw-my-2.5 tw-flex tw-flex-col tw-gap-1.5 tw-py-2.5">
        {/* Keep subheadings left-aligned with field labels and section titles.
          which left each heading floating over left-aligned content; the add/edit FORM (`recipe-*.tsx`)
          never centred them, so card and form disagreed. Weight/size unchanged. */}
        <h4 className="tw-m-0 tw-text-lg tw-font-medium tw-leading-[27px]">
          <FormattedMessage id="HEADER_CANINE" />
        </h4>

        <span className="tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-text-brand-gray sm:tw-text-sm">
          <FormattedMessage id="HEADER_CANINE_DESCRIPTION" />
        </span>
      </div>

      <div className="row">
        <LabelledValue className="form-group col-md-3" label={<FormattedMessage id="CANINE_RIGHT" />}>
          <FormattedMessage id={translateRxOption("canine_ratio_right", canine_ratio_right)} />
        </LabelledValue>

        <LabelledValue className="form-group col-md-3" label={<FormattedMessage id="CANINE_LEFT" />}>
          <FormattedMessage id={translateRxOption("canine_ratio_left", canine_ratio_left)} />
        </LabelledValue>

        {canine_method_ai ? (
          <LabelledValue className="form-group col-lg-4 col-sm-6" label={<FormattedMessage id="CANINE_HOWTO" />}>
            <FormattedMessage id={translateRxOption("canine_method_ai", `${canine_method_ai}`)} />
          </LabelledValue>
        ) : (
          <>
            <LabelledValue className="form-group col-md-3" label={<FormattedMessage id="CANINE_HOWTO" />}>
              <FormattedMessage id={translateRxOption("canine_method", canine_method)} />
            </LabelledValue>

            {canine_ipr ? (
              <div className="form-group col-lg-3 col-sm-5">
                <p style={{ marginTop: "10px" }}>
                  <FormattedMessage id={translateRxOption("canine_ipr", `${canine_ipr}`)} />
                </p>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
